module.exports = __webpack_public_path__ + "static/media/sopt22ru.b2a6d7c3.pdf";